export default __webpack_public_path__ + "static/mockSeikaku3-b021c2fda1215fa20da9c6869b43e8bd.png";